import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import get from 'lodash.get';

import DownloadIcon from '@mui/icons-material/CloudDownload';
import IconButton from '@mui/material/IconButton';

const styles = theme => ({
    button: {
      margin: theme.spacing.unit,
    },
    input: {
      display: 'none',
    },
  });

const DownloadButton = ({ source, record = {}, elStyle }) => {
    return (
      <a href={get(record, source)} download="">
                  <IconButton variant="raised" size="large"><DownloadIcon/></IconButton>
              </a>
    );
}

DownloadButton.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default withStyles(styles)(DownloadButton);